import { AppStreamSDK } from "./AppStreamSDK";
import log, { METRIC_NAME } from "../logging";
import { ClientMessageType } from "../constants/clientMessage";
import { ApplicationName } from "../hooks/useAppStreamApplications";
import { sendSendClientMessageCommand as sendClientMessageCommand } from "./ermineSsrClientUtil";
import { ClientMessage } from "@amzn/ermine-server-side-rendering-client";
import { getFormattedSdkErrorMessage } from "./errorUtils";
import { getEnvInfo, getPortalConfig } from "./configurationUtils";

export async function sendClientMessage(
    appStreamSdk: AppStreamSDK,
    deepLinks,
    onErrorCallback
) {
    const message = buildClientMessage(deepLinks);
    if (message == null) {
        return;
    }

    const { stage, region } = getEnvInfo();
    try {
        const data = await sendClientMessageCommand({
            portalArn: getPortalConfig().portalArn,
            message: message!,
        });

        log.info(`Client message sent with ID: ${data?.messageId}`);
        log.publishHttpStatusMetric(METRIC_NAME.SEND_CLIENT_MESSAGE, 200);
        let appName;
        if (stage === "prod") {
            appName = "ClientMessageHandler";
        } else {
            // App name contains developer alias in preprod if custom Appblock is used.
            // Note this call adds around 500ms to e2e latency for features replies on it like deep
            // link.
            const applications = await appStreamSdk.getApplications();
            appName = applications.find(
                (app) =>
                    app.displayName === ApplicationName.CLIENT_MESSAGE_HANDLER
            )?.name;
        }
        appStreamSdk.launchApp(appName);
    } catch (err) {
        const statusCode = err.$metadata?.httpStatusCode;
        onErrorCallback(statusCode, message.openDeepLinks.deepLinks);
        await log.error(
            err
                ? getFormattedSdkErrorMessage(err, "SendClientMessage")
                : "Failed to send client message"
        );
        log.publishHttpStatusMetric(
            METRIC_NAME.SEND_CLIENT_MESSAGE,
            statusCode
        );
    }
}

export function buildClientMessage(deepLinks): ClientMessage {
    if (!Array.isArray(deepLinks)) {
        log.error("Invalid type. Deep links is not an array");
        return;
    }

    if (!deepLinks?.length) {
        return;
    }

    return {
        type: ClientMessageType.OPEN_DEEP_LINKS,
        openDeepLinks: {
            deepLinks,
        },
    };
}
